import { Link } from "react-router-dom";
import { ASSETS, BRAND } from "@/lib/brand";
import Footer from "@/components/site/Footer";

export default function LegalLayout({ title, kicker, children, testId }) {
  return (
    <main className="min-h-screen bg-white text-[#0A0A0A]" data-testid={testId}>
      {/* Mini header */}
      <header className="border-b border-[#EAEAEA] bg-[#FDFBF7]">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-12 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="legal-back-home">
            <img
              src={ASSETS.logo}
              alt="La Valle degli Iblei stemma"
              className="h-10 w-10 object-contain"
            />
            <span className="font-serif-display text-base text-[#0A0A0A] hidden sm:inline">
              La Valle degli Iblei
            </span>
          </Link>
          <Link
            to="/"
            className="overline text-[10px] hover:text-[#0A0A0A] flex items-center gap-2"
          >
            <span>←</span> Torna alla Home
          </Link>
        </div>
      </header>

      <article className="max-w-[860px] mx-auto px-6 sm:px-10 py-20 sm:py-28">
        <div className="flex items-center gap-6 mb-8">
          <div className="h-px w-12 bg-[#0A0A0A]" />
          <span className="overline text-[10px]">{kicker}</span>
        </div>
        <h1
          className="font-serif-display leading-[0.95] text-[#0A0A0A] mb-12"
          style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)" }}
        >
          {title}
        </h1>

        <div className="legal-content space-y-8 text-[15.5px] leading-[1.85] text-[#2C2C2C] font-light">
          {children}
        </div>

        <div className="mt-20 pt-10 border-t border-[#EAEAEA] flex flex-col sm:flex-row gap-4 justify-between items-start">
          <p className="text-xs text-[#5C5C5C]">
            Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long", day: "numeric" })}
          </p>
          <p className="text-xs text-[#5C5C5C]">
            © {new Date().getFullYear()} La Valle degli Iblei — {BRAND.founder}
          </p>
        </div>
      </article>

      <Footer />
    </main>
  );
}

export function LegalSection({ num, title, children }) {
  return (
    <section className="grid grid-cols-1 md:grid-cols-12 gap-6 pb-6 border-b border-[#EAEAEA]">
      <div className="md:col-span-3">
        <span className="font-serif-display italic text-3xl text-[#C4A671]">
          {num}
        </span>
        <h2 className="font-serif-display text-xl mt-2 text-[#0A0A0A] leading-tight">
          {title}
        </h2>
      </div>
      <div className="md:col-span-9 space-y-4">{children}</div>
    </section>
  );
}
